import { render, staticRenderFns } from "./PageListHeader.vue?vue&type=template&id=563ed87a&scoped=true&"
var script = {}
import style0 from "./PageListHeader.vue?vue&type=style&index=0&id=563ed87a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ed87a",
  null
  
)

export default component.exports